import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthService from "../services/authService";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { IconHomeFilled } from "@tabler/icons-react";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authService = AuthService();
  const user = authService.getCurrentUser();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    authService.logout();
    navigate("/login");
  };

  const [show, setShow] = useState(true);

  useEffect(() => {
    let previousScrollPosition = 0;

    const handleScroll = () => {
      const currentScrollPosition = window.pageYOffset;

      if (previousScrollPosition - currentScrollPosition < 0) {
        setShow(false);
      } else if (previousScrollPosition - currentScrollPosition > 0) {
        setShow(true);
      }

      previousScrollPosition = currentScrollPosition;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Handle scrolling after navigation
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", ""); // Extract id from the hash
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      {/* Desktop Navbar */}
      <nav className={`main-nav desktop ${show ? "show" : "hide"}`}>
        <Link className="main-nav__link" to="/">
          Home
        </Link>
        <Link className="main-nav__link" to="/properties">
          Propiedades
        </Link>
        <Link className="main-nav__link" to="/#services">
          Servicios
        </Link>
        <Link className="main-nav__link" to="/">
          Avaluos
        </Link>
        <Link className="main-nav__link" to="/#contact">
          Contacto
        </Link>
        {user ? (
          <>
            <Link className="main-nav__link" to="/dashboard">
              Dashboard
            </Link>
            <button className="main-nav__button" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <Link className="main-nav__link" to="/login">
            Login
          </Link>
        )}
      </nav>

      {/* Mobile Navbar */}
      <nav className={`main-nav mobile ${show ? "show" : "hide"}`}>
        <div className="main-nav--responsive">
          <IconHomeFilled />
        </div>
        <div className="main-nav--responsive" onClick={toggleMenu}>
          {menuOpen ? <IconX stroke={2} /> : <IconMenu2 stroke={2} />}
        </div>

        <div className={`main-nav__links ${menuOpen ? "open" : ""}`}>
          <Link className="main-nav__link" to="/">
            Home
          </Link>
          <Link className="main-nav__link" to="/properties">
            Propiedades
          </Link>
          <Link className="main-nav__link" to="/#services">
            Servicios
          </Link>
          <Link className="main-nav__link" to="/">
            Avaluos
          </Link>
          <Link className="main-nav__link" to="/#contact">
            Contacto
          </Link>
          {user ? (
            <>
              <Link className="main-nav__link" to="/dashboard">
                Dashboard
              </Link>
              <button className="main-nav__button" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <Link className="main-nav__link" to="/login">
              Login
            </Link>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
